'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoachBrowserDomGateway = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _aureliaFramework = require('aurelia-framework');

var _coreEs = require('@mojility/core-es6');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoachBrowserDomGateway = exports.CoachBrowserDomGateway = (_dec = (0, _aureliaFramework.inject)(_coreEs.Configuration, _coreEs.BrowserLocationGateway), _dec(_class = function (_BrowserDomGateway) {
  _inherits(CoachBrowserDomGateway, _BrowserDomGateway);

  function CoachBrowserDomGateway(configuration, browserLocationGateway) {
    _classCallCheck(this, CoachBrowserDomGateway);

    var _this = _possibleConstructorReturn(this, (CoachBrowserDomGateway.__proto__ || Object.getPrototypeOf(CoachBrowserDomGateway)).call(this));

    _this.config = configuration;
    _this.browserLocationGateway = browserLocationGateway;
    return _this;
  }

  _createClass(CoachBrowserDomGateway, [{
    key: 'buildStylesheetUrl',
    value: function buildStylesheetUrl(baseUrl) {
      var hostname = this.browserLocationGateway.domainName;
      return baseUrl + '/css/hostname/' + hostname;
    }
  }, {
    key: 'appendCssLinkToDom',
    value: function appendCssLinkToDom() {
      var baseUrl = this.config.settings.serviceUrl;
      var el = this.createLinkElement(this.buildStylesheetUrl(baseUrl));
      this.appendToHead(el);
    }
  }]);

  return CoachBrowserDomGateway;
}(_coreEs.BrowserDomGateway)) || _class);